import cn from "classnames";
import LoaderIcon from '@assets/icons/outline/loader-circle.svg?react';
import styles from "./Loader.module.scss";

const Loader = ({ className }: { className?: string }) => {
  return (
    <div className={cn(styles.loader, className)}>
      <LoaderIcon />
    </div>
  );
};

export default Loader;
